import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../../assets/css/admin.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#f8f9fa",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        textAlign: "center",
    },
    overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 1000,
    },
};

Modal.setAppElement("#root");

const TemoignageAdmin = () => {
    const { t } = useTranslation("admin");
    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const API_BASE_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchAdminTestimonials = async () => {
            try {
                const token = localStorage.getItem("adminToken");
                if (!token) {
                    navigate("/connexion");
                    return;
                }
                const response = await axios.get(
                    `${API_BASE_URL}/api/admin/testimonials/all`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setTestimonials(response.data);
                setLoading(false);
            } catch (err) {
                console.error(
                    "Erreur lors du chargement des témoignages pour l'admin:",
                    err
                );
                setError(t("erreur_chargement_temoignages"));
                setLoading(false);
                if (err.response && err.response.status === 401) {
                    navigate("/connexion");
                }
            }
        };

        fetchAdminTestimonials();
    }, [navigate, t]);

    const openConfirmationModal = (item) => {
        setItemToDelete(item);
        setConfirmationModalOpen(true);
    };

    const closeConfirmationModal = () => {
        setItemToDelete(null);
        setConfirmationModalOpen(false);
    };

    const handleConfirmDelete = async () => {
        if (itemToDelete) {
            try {
                const token = localStorage.getItem("adminToken");
                if (!token) {
                    navigate("/connexion");
                    return;
                }
                await axios.delete(
                    `${API_BASE_URL}/api/admin/testimonials/${itemToDelete}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setTestimonials(
                    testimonials.filter((t) => t.id !== itemToDelete)
                );
            } catch (err) {
                console.error(
                    "Erreur lors de la suppression du témoignage:",
                    err
                );
                setError(t("erreur_action"));
                if (err.response && err.response.status === 401) {
                    navigate("/connexion");
                }
            } finally {
                closeConfirmationModal();
            }
        }
    };

    return (
        <section className="manage-testimonials admin-dashboard">
            <h2>{t("manage_testimonials")}</h2>
            {loading && <p>{t("chargement")}</p>}
            {error && <p className="error-message">{error}</p>}
            {!loading && !error && (
                <table>
                    <thead>
                        <tr>
                            <th>{t("auteur")}</th>
                            <th>{t("texte")}</th>
                            <th>{t("likes")}</th>
                            <th>{t("actions")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {testimonials.map((testimonial) => (
                            <tr key={testimonial.id}>
                                <td>{testimonial.nom_auteur}</td>
                                <td>{testimonial.texte}</td>
                                <td>{testimonial.likes || 0}</td>
                                <td>
                                    <button
                                        className="deleteadm"
                                        onClick={() =>
                                            openConfirmationModal(
                                                testimonial.id
                                            )
                                        }
                                        style={{
                                            backgroundColor: "#dc3545",
                                            color: "white",
                                            border: "none",
                                            padding: "8px 15px",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            fontSize: "0.9rem",
                                        }}
                                    >
                                        {t("delete_reservation")}
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            <Modal
                isOpen={confirmationModalOpen}
                onRequestClose={closeConfirmationModal}
                style={customStyles}
                contentLabel={t("confirmation_modal_title")}
            >
                <h2>{t("confirmation_modal_title")}</h2>
                <p>{t("confirm_delete_testimonial")}</p>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                        marginTop: "20px",
                    }}
                >
                    <button
                        onClick={handleConfirmDelete}
                        style={{
                            backgroundColor: "#28a745",
                            color: "white",
                            border: "none",
                            padding: "10px 20px",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "1rem",
                        }}
                    >
                        {t("confirm")}
                    </button>
                    <button
                        onClick={closeConfirmationModal}
                        style={{
                            backgroundColor: "#6c757d",
                            color: "white",
                            border: "none",
                            padding: "10px 20px",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "1rem",
                        }}
                    >
                        {t("cancel")}
                    </button>
                </div>
            </Modal>
        </section>
    );
};

export default TemoignageAdmin;
